"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";

export function PlausibleAnalytics() {
  const pathname = usePathname();
  if (pathname?.startsWith("/ops-console")) return null;

  return (
    <>
      <Script
        src="https://analytics.thecybersky.com/js/pa-ArIqPy44rm3qYM5Afz-LY.js"
        strategy="afterInteractive"
      />
      <Script id="plausible-init" strategy="afterInteractive">
        {`window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},plausible.init=plausible.init||function(i){plausible.o=i||{}};
plausible.init()`}
      </Script>
    </>
  );
}
